export default __webpack_public_path__ + "img/bornToday.0b5974e0.svg";